import Dexie, { Table } from 'dexie';

export interface ChatMessage {
    id?: number;
    eventId?: string;
    chatId: string;
    text: string;
    filename: string;
    timestamp: number;
    senderId: string;
    sender?: string;
    isRead: boolean;
    msgtype?: string;
    subtype?: string;
    url?: string;
    info?: any;
    deleted: boolean;
}

export interface CachedRoom {
    roomId: string;
    name: string;
    room_avatar?: string | null;
    room_color?: string | null;
    room_type?: string | null;
    lastEvent: number;
    unreadCount: number;
    lastMessage: any;
    eventInformation?: any;
}

export interface CachedImage {
    mediaId: string;
    blob: Blob;
    cachedAt: number;
}

export interface AppPreference {
    key: string;
    value: string;
}

export class AppDB extends Dexie {
    messages!: Table<ChatMessage, number>;
    rooms!: Table<CachedRoom, string>;
    images!: Table<CachedImage, string>;
    preferences!: Table<AppPreference, string>;

    constructor() {
        super('ChatDatabase');

        this.version(2).stores({
            messages: '++id, chatId, timestamp, senderId',
            preferences: 'key'
        });
        this.version(3).stores({
            messages: '++id, chatId, timestamp, senderId, eventId',
            rooms: 'roomId, lastEvent',
            preferences: 'key'
        });
        this.version(4).stores({
            messages: '++id, chatId, timestamp, senderId, eventId',
            rooms: 'roomId, lastEvent',
            images: 'mediaId, cachedAt',
            preferences: 'key'
        });
    }
}

export const db = new AppDB();
